
import { Vue, Component } from 'vue-property-decorator'
import { CommonService } from '@/services'
import { ElForm } from 'element-ui/types/form'
import { isValidURL } from '@/common/utils'

@Component({})
export default class ListTitle extends Vue {
    private eventId = 0
    private isLoading = false
    private event: any = {
        type: {}
    }
    private eventRules = {
        title: [
            { 
                required: true, 
                min: 2, 
                max: 100, 
                message: '长度在 2 到 100 个字符' 
            }
        ],
        abstract: [
            { 
                required: true, 
                min: 1, 
                max: 2000, 
                message: '长度在 1 到 2000 个字符' 
            }
        ],
        logo: [
            { required: true, validator: this.urlValidator }
        ],
        start_at: [
            { required: true, message: '请选择开始时间' }
        ]
        // end_at: [
        //     { required: true, message: '请选择结束时间' }
        // ]
    }

    private urlValidator(rule: any, value: string, callback: Function) {
        // 检验网址
        let message = '请输入正确的链接地址'
        if (!value) return callback(message)
        if (!isValidURL(value)) {
            return callback(message)
        }
        if (value.length > 300) {
            message = '链接长度在 300 个字符以内'
            return callback(message)
        }
        callback()
    }

    get eventForm() {
        return this.$refs.eventRef as ElForm
    }

    private created() {
        this.eventId = +this.$route.params.id
    }
    private mounted() {
        this.getEventDetail()
    }
    // 获取事件详情
    private async getEventDetail() {
        this.isLoading = true
        const result = await CommonService.getEventDetail({ id: this.eventId })
        this.isLoading = false
        if (result.status === 200) {
            this.event = result.data
        }
    }

    // 更新事件信息
    private async updateEventInfo() {
        const params = {
            id: this.eventId,
            title: this.event.title,
            abstract: this.event.abstract,
            logo: this.event.logo,
            start_at: this.event.start_at,
            end_at: this.event.end_at
        }
        const result = await CommonService.updateEvent(params)
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '更新成功',
                showClose: true
            })
            return true
        }
        this.$message({
            type: 'error',
            message: result.message,
            showClose: true
        })
        return false
    }

    private onSave() {
        this.eventForm.validate(async (isValid: boolean) => {
            if (isValid) {
                const result = await this.updateEventInfo()
                if (result) {
                    return this.$router.go(-1)
                }
            }
        })
    }

}
